import { render, staticRenderFns } from "./show.support.page.vue?vue&type=template&id=2133f83b&scoped=true&"
import script from "./show.support.page.vue?vue&type=script&lang=js&"
export * from "./show.support.page.vue?vue&type=script&lang=js&"
import style0 from "./show.support.page.vue?vue&type=style&index=0&id=2133f83b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2133f83b",
  null
  
)

export default component.exports